import { render, staticRenderFns } from "./TheBuyPassport.vue?vue&type=template&id=18dc7551&"
import script from "./TheBuyPassport.vue?vue&type=script&lang=js&"
export * from "./TheBuyPassport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports